export default __webpack_public_path__ + "static/media/hr-payroll-management.c50d2ac5.svg";